/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { States } from 'services/states';
import { StatesTypes } from 'store/modules/online_search_store/types';
import Api from 'services/api';
import { Container } from './styles';

interface ModalAddFilterProps {
  setShowAddModal: React.Dispatch<React.SetStateAction<boolean>>;
  showAddModal: boolean;
  users_filter: Array<string>;
}

const ModalAddFilter = (props: ModalAddFilterProps) => {
  const { setShowAddModal, showAddModal, users_filter } = props;
  const [title, setTitle] = useState<string>('');
  const [cidades, setCidades] = useState<string>('');
  const [users, setUsers] = useState<Array<any>>([]);
  const [states, setStates] = useState<Array<StatesTypes>>([]);
  const [segmentos, setSegmentos] = useState<string>('');
  const [palavraChave, setPalavraChave] = useState<string>('');
  const [observacao, setObservacao] = useState<string>('');
  const [morning, setMorning] = useState<boolean>(false);
  const [afternoon, setAfternoon] = useState<boolean>(false);
  const [night, setNight] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(true);

  useEffect(() => {
    title.length !== 0 && users.length !== 0 && segmentos.length !== 0 && setDisableButton(false);
  });

  return (
    <Modal className="m-0" size="lg" show={showAddModal}>
      <Container>
        <div className="modal-header">
          <h5 className="modal-title">Solicitar adição de filtro</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={() => setShowAddModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12">
              <label htmlFor="title">Título:</label>
              <input
                type="text"
                className="form-control"
                id="title"
                placeholder="Escreva um título para esse filtro"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Usuários</label>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <Select
                isMulti
                name="users"
                options={users_filter?.map((user) => {
                  return { label: `${user[0]} - (${user[1]})`, value: user };
                })}
                placeholder="Selecione os usuários"
                classNamePrefix="select"
                className="basic-multi-select"
                onChange={(event) => setUsers([...event])}
              />
            </div>
          </div>
          <hr />
          <h4 className="font-weight-bold">Licitações</h4>
          <p className="mb-0">Período</p>
          <div className="row p-3 mt-0">
            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={morning}
                id="morning"
                onChange={(e) => setMorning(e.target.checked)}
              />
              <label className="form-check-labe mt-1" htmlFor="manha">
                Manhã
              </label>
            </div>
            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={afternoon}
                id="afternoon"
                onChange={(e) => setAfternoon(e.target.checked)}
              />
              <label className="form-check-label mt-1" htmlFor="manha">
                Tarde
              </label>
            </div>
            <div className="col-md-8">
              <input
                className="form-check-input"
                type="checkbox"
                checked={night}
                id="afternoon"
                onChange={(e) => setNight(e.target.checked)}
              />
              <label className="form-check-label mt-1" htmlFor="manha">
                Noite
              </label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Segmentos</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Ex.: Gostaria de tudo relacionado a Painéis, luminosos, faixas, displays, plaqueta patrimonial"
              rows={3}
              value={segmentos}
              onChange={(event) => setSegmentos(event.target.value)}
            />
          </div>
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Estado</label>
            </div>
            <div className="float-right date-template">
              <button
                type="button"
                className="btn btn-sm btn-link pr-0"
                onClick={() => setStates(States)}
              >
                Todos os estados
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <Select
                isMulti
                name="estado"
                options={States}
                value={states || ''}
                closeMenuOnSelect={false}
                placeholder="Selecione um ou mais estados"
                classNamePrefix="select"
                className="basic-multi-select"
                onChange={(event) => setStates([...event])}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Cidade</label>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <textarea
                className="form-control"
                id="cidades"
                name="cidades"
                placeholder="Descreva as cidades"
                rows={3}
                value={cidades}
                onChange={(event) => setCidades(event.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Palavras-chave</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Escreva todas as palavras-chaves relacionadas"
              rows={3}
              value={palavraChave}
              onChange={(event) => setPalavraChave(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Observações</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Escreva qualquer outra especificação para esse filtro"
              rows={3}
              value={observacao}
              onChange={(event) => setObservacao(event.target.value)}
            />
          </div>
          <p>Obs.: Será enviada uma solicitação para nossos consultores adicionarem esse filtro</p>
          <hr />
          <div className="text-center">
            <button
              type="button"
              className="btn btn-primary"
              disabled={disableButton}
              onClick={() =>
                Api.post('/solicitation_add_filter', {
                  users,
                  title,
                  cidades,
                  states,
                  segmentos,
                  palavraChave,
                  observacao,
                  morning,
                  afternoon,
                  night,
                }).then((response) => {
                  if (response.status === 200) {
                    setShowAddModal(false);
                  }
                })
              }
            >
              Solicitar novo filtro
            </button>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalAddFilter;
